import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/browser'

let isFetching = false
let fetchPromise = null

export default api => {
  async function isLoggedIn() {
    try {
      const session = await Auth.currentSession()

      if (!session || !session.isValid()) return false

      return true
    } catch (err) {
      return false
    }
  }

  return {
    /**
     * Returns the currently logged in user, or null if not logged in.
     */
    async getUser() {
      if (!(await isLoggedIn())) {
        Sentry.setUser(null)
        return null
      }

      if (isFetching) {
        return fetchPromise
      }

      isFetching = true

      fetchPromise = new Promise((resolve, reject) =>
        api
          .get(`/api/v3/users/me`)
          .then(res => resolve(res.data))
          .catch(e => reject(e))
      )

      const user = await fetchPromise
      try {
        Sentry.setUser({
          email: user.email || '',
          username: user.username || '',
          ip_address: '{{auto}}',
        })
      } catch {}

      isFetching = false
      fetchPromise = null

      return user
    },

    /**
     * Updates the user with the provided payload.
     */
    async updateUser(payload) {
      const { data } = await api.patch(`/api/v3/users/me`, payload)

      return data
    },

    /**
     * Deletes the user with the provided payload.
     */
    async deleteUser() {
      await api.delete(`/api/v3/users/me`)
    },
  }
}
